import { createAction, makeActionTrackable } from '@lingoda/core';
import type { Section } from './models';

export const addSection = createAction<Section>('route/ADD_SECTION');

export const addSections = createAction<Section[]>('section/ADD_SECTIONS');

export const fetchSections = makeActionTrackable(createAction('section/FETCH_SECTIONS'));
